module.exports = __webpack_public_path__ + "static/img/lc1-4.c6d320d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/lc1-4.png
// module id = 836
// module chunks = 0